import { DatePicker } from '@polyv/polyv-ui';
import dayjs from 'dayjs';

export const formatDate = DatePicker.formatData;

// 获取快捷日期
// end 为当前天00:00:00 是避免dataPicker组件显示异常
// 可以通过getDateRangeTimestamp来获取到对应end日期的23:59:59
// 例如 [start, end] = this.getDateRangeTimestamp(dataRange)
export function getFastDateTimeStamp(type) {
  let start;
  let end;
  const t = new Date();
  const year = t.getFullYear();
  const month = t.getMonth();
  const date = t.getDate();
  switch (type) {
    case 'today':
      start = new Date(year, month, date, 0, 0, 0);
      end = new Date(year, month, date, 0, 0, 0);
      break;
    case 'yesterday':
      start = new Date(year, month, date - 1, 0, 0, 0);
      end = new Date(year, month, date - 1, 0, 0, 0);
      break;
    case 'last7Day':
      start = new Date(year, month, date - 6, 0, 0, 0);
      end = new Date(year, month, date, 0, 0, 0);
      break;
    case 'last30Day':
      start = new Date(year, month, date - 29, 0, 0, 0);
      end = new Date(year, month, date, 0, 0, 0);
      break;
    case 'onMonth':
      start = getMonthStartEndTime(new Date()).start;
      end = new Date(year, month, date, 0, 0, 0);
      break;
    default:
      break;
  }
  return [start, end];
}

/**
 * 获取当前月份的开始时间和结束时间
 */
export function getCurrentMonthTimestamp() {
  return [
    dayjs().startOf('month').valueOf(),
    dayjs().endOf('month').valueOf()
  ];
}

// 获取每月开始结束时间
export function getMonthStartEndTime(date) {
  if (typeof date === 'number') {
    date = new Date(date);
  }
  const year = date.getFullYear();
  const month = date.getMonth();
  const start = new Date(year, month, 1);
  let end = new Date(year, month + 1, 0);
  if (end > new Date()) {
    end = new Date();
  }
  return {
    start: clearTimeStamp(start),
    end: clearTimeStamp(end)
  };
}

// 统一日期的时间戳
export function clearTimeStamp(dateObj) {
  if (typeof dateObj === 'number') {
    dateObj = new Date(dateObj);
  }
  if (!(dateObj instanceof Date)) return null;
  return new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate(), 0, 0, 0);
}

export function getDateRangeTimestamp(date, { isEndTimeStamp = true } = {}) {
  let startTime;
  let endTime;
  if (!Array.isArray(date)) {
    startTime = '';
    endTime = '';
  } else {
    if (date[0] && date[0] instanceof Date) {
      startTime = date[0].getTime();
    } else if (date[0] && typeof date[0] === 'number') {
      startTime = date[0];
    }
    if (date[1] && date[1] instanceof Date) {
      endTime = date[1].getTime();
    } else if (date[1] && typeof date[1] === 'number') {
      endTime = date[1];
    }
    if (endTime && isEndTimeStamp) {
      const endDate = new Date(endTime);
      const year = endDate.getFullYear();
      const month = endDate.getMonth();
      const date = endDate.getDate();
      endTime = new Date(year, month, date, 0, 0, 0).getTime() + 24 * 3600 * 1000 - 1000;
    }
  }
  return {
    startTime,
    endTime
  };
}

// 秒数转成时长字符串
export const formatDuration = (duration, type) => {
  if (!duration) {
    if (type === 'time') {
      return '00:00:00';
    }
    return duration;
  }
  let seconds = Math.floor(duration % 60);
  let minutes = Math.floor((duration / 60) % 60);
  let hours = Math.floor(duration / 3600);
  if (seconds < 10) {
    seconds = `0${seconds}`;
  }

  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  if (hours < 10) {
    hours = `0${hours}`;
  }
  return `${hours}:${minutes}:${seconds}`;
};

// 数字转化千分位
export function commafy(num) {
  if ((num + '').trim() === '') {
    return '';
  }
  if (isNaN(num)) {
    return '';
  }
  num = num + '';
  if (/^.*\..*$/.test(num)) {
    const pointIndex = num.lastIndexOf('.');
    let intPart = num.substring(0, pointIndex);
    const pointPart = num.substring(pointIndex + 1, num.length);
    intPart = intPart + '';
    const re = /(-?\d+)(\d{3})/;
    while (re.test(intPart)) {
      intPart = intPart.replace(re, '$1,$2');
    }
    num = intPart + '.' + pointPart;
  } else {
    num = num + '';
    const re = /(-?\d+)(\d{3})/;
    while (re.test(num)) {
      num = num.replace(re, '$1,$2');
    }
  }
  return num;
}

export const exportFile = (url, target = '_blank') => {
  const isHttpsProtocol = url.includes('https');
  const jumpUrl = isHttpsProtocol ? url : url.replace(/^http/, 'https');
  window.open(jumpUrl, target);
};

export const isNoAssignment = (value) => {
  return value === undefined || value === null;
};

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function objectToFormData(obj) {
  const formData = new FormData();
  for (const key in obj) {
    formData.append(key, obj[key]);
  }
  return formData;
}

/**
 * 校验密码同时包含数字和英文，长度为686位
 * @param {String} str 待校验字符串
 * @param {String} type 判断是修改频道密码、角色密码还是账号密码
 * @returns {Boolean} 返回true/false
 */
export function checkPasswd(str) {
  if (!str) return false;
  // 检查是否包含<>
  return /^(?=.*[0-9])(?=.*[a-zA-Z])[A-Za-z0-9`~!@#$%&^*()_+-=?:|{}'",./\\;[\]]{8,16}$/.test(str);
}
